import React, { useState, useEffect } from 'react';
import './CheckinPage.css'; 
import TituloComponent from '../../components/Titulo/TituloComponent';
import { useNavigate } from 'react-router-dom';  
import { buscarEstabelecimentos } from '../../services/api'; 

const CheckinPage = () => {
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [error, setError] = useState(null);
  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();  
  const userData = JSON.parse(sessionStorage.getItem('userData')) || {};

  const handleClick = (estabelecimento) => {
    navigate('/mostrar-dados-estabelecimento', { state: { estabelecimento } });
  };

  // Função para obter a localização do usuário e armazenar na sessionStorage
  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;

            // Se a latitude ou longitude forem 0, não salva na sessionStorage
            if (latitude === 0 && longitude === 0) {
              reject("Localização inválida recebida (0,0).");
              return;
            }

            setLatitude(latitude);
            setLongitude(longitude);

            // Atualiza o userData com a latitude e longitude
            const updatedUserData = { ...userData, latitude, longitude };

            // Salva o objeto atualizado no sessionStorage
            sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
            sessionStorage.setItem('latitude', latitude);
            sessionStorage.setItem('longitude', longitude);

            resolve({ latitude, longitude });
          },
          (err) => {
            setError(err.message);
            reject(err);
          }
        );
      } else {
        const errorMessage = "Geolocalização não suportada pelo navegador.";
        setError(errorMessage);
        reject(errorMessage);
      }
    });
  };

  // Função para buscar os estabelecimentos da API
  const fetchEstabelecimentos = async () => {
    const storedUserData = JSON.parse(sessionStorage.getItem('userData')) || {};

    // Verifica se latitude e longitude são válidos antes de chamar a API
    if (storedUserData.latitude && storedUserData.longitude && storedUserData.latitude !== 0 && storedUserData.longitude !== 0) {
      try {
        const response = await buscarEstabelecimentos(storedUserData); 
        setEstabelecimentos(response.estabelecimentos); 
      } catch (error) {
        setError("Erro ao carregar os estabelecimentos");
      } finally {
        setLoading(false); 
      }
    } else {
      setError("Localização inválida. Não foi possível buscar os estabelecimentos.");
      setLoading(false);
    }
  };

  // Chama as funções para obter a localização e buscar os estabelecimentos assim que o componente for montado
  useEffect(() => {
    const loadData = async () => {
      try {
        await getLocation(); // Espera a localização ser capturada
        await fetchEstabelecimentos(); // Depois chama a API para buscar os estabelecimentos
      } catch (err) {
        console.log("Erro ao capturar localização ou buscar estabelecimentos:", err);
      }
    };

    loadData();
  }, []);

  const BASE_API =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://127.0.0.1:8000'
      : 'https://mercadinhointeligente.com.br';

  return (
    <div className="checkin-container">
      <TituloComponent /> 

      {loading ? (
        <p>Carregando estabelecimentos...</p>
      ) : (
        <div className="logobar-carousel">
          {estabelecimentos.length > 0 ? (
            estabelecimentos.map((estab) => {
              const imageUrl = `${BASE_API}/storage/imagens/bares/${estab.id}.png`;

              return (
                <div key={estab.id} onClick={() => handleClick(estab)} className="estabelecimento-item">
                  <img 
                    src={imageUrl} 
                    alt={estab.nome} 
                    className="logobar-image" 
                  />
                  <p>{estab.nome}</p>
                </div>
              );
            })
          ) : (
            <p>Nenhum estabelecimento encontrado.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default CheckinPage;
